var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4538 13.7179L13.7765 14.1429C13.8214 14.2021 13.8488 14.2725 13.8555 14.3463C13.8622 14.42 13.8481 14.4941 13.8146 14.5604C13.7811 14.6266 13.7296 14.6823 13.6658 14.7212C13.6021 14.7601 13.5287 14.7807 13.4538 14.7807H0.546214C0.471305 14.7807 0.397876 14.7601 0.334155 14.7212C0.270433 14.6823 0.218937 14.6266 0.185437 14.5604C0.151937 14.4941 0.137756 14.42 0.144483 14.3463C0.15121 14.2725 0.17858 14.2021 0.223525 14.1429L0.546214 13.7179V6.80733C0.546214 5.11558 1.22616 3.49312 2.43648 2.29688C3.6468 1.10063 5.28835 0.428589 7 0.428589C8.71165 0.428589 10.3532 1.10063 11.5635 2.29688C12.7738 3.49312 13.4538 5.11558 13.4538 6.80733V13.7179ZM4.98319 15.5781H9.0168C9.0168 16.1068 8.80432 16.6138 8.42609 16.9876C8.04787 17.3614 7.53489 17.5714 7 17.5714C6.46511 17.5714 5.95212 17.3614 5.5739 16.9876C5.19567 16.6138 4.98319 16.1068 4.98319 15.5781Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemind);
export default __webpack_public_path__ + "static/media/Remind.e0ea6d908e664512344afca2c6861ffe.svg";
export { ForwardRef as ReactComponent };